// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__bD_0y","title":"InfoRow_title__UBqbb"};